'use client';
import {Share, Share2} from "lucide-react";
import {Button} from "@/shadcn/components/ui/button";
import {Variant} from "@/types";
import {toast} from "sonner";

export const ShareButton = ({variant, size = 'button'}: { variant: Variant, size?: 'sm' | 'button' }) => {
    const onShare = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (navigator.share) {
            navigator.share({
                title: variant.title,
                text: `${variant.brand_name} - ${variant.title}`,
                url: window.location.href
            })
                .catch(error => console.error('Error sharing:', error));
        } else {
            // Fallback for browsers that don't support Web Share API
            navigator.clipboard.writeText(window.location.href)
                .then(() => {
                    toast.success(<p className={'ml-2'}>Link in die Zwischenablage kopiert!</p>);
                })
                .catch(err => console.error('Failed to copy: ', err));
        }
    }

    if (size === 'sm') {
        return (
            <Button
                onClick={onShare}
                size="sm"
                variant="outline"
                aria-label="Produkt teilen"
                className="h-8 w-8"
            >
                <Share2 className="h-4 w-4 text-slate-700" aria-hidden="true"/>
            </Button>
        );
    }

    return (
        <Button
            onClick={onShare}
            className="w-full h-auto flex items-center px-4"
            variant="outline"
        >
            <Share className="h-4 w-4 mr-2"/>
            Teilen
        </Button>
    );
}
